import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Dropdown, Input, Accordion, Icon, Checkbox } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import Config from '../config';
const fileDownload = require('js-file-download');

class State {
    drmSys: string;
    synamediaServerUrl: string;
    synamediaServerUsername: string;
    synamediaServerPassword: string;
    ezdrmServerUrl: string;
    ezdrmServerUsername: string;
    ezdrmServerPassword: string;
    ezdrmUsernamePlaceholder: string;
    ezdrmPasswordPlaceholder: string;
    ezdrmServerAuthMethod: string;
    ezdrmServerAwsAccessKeyId: string;
    ezdrmServerAwsSecretKey: string;
    ezdrmServerKeyTypeWidevine: boolean;
    ezdrmServerKeyTypePlayReady: boolean;
    ezdrmServerKeyTypeFairplay: boolean;
    irdetoGatewayUrl: string;
    irdetoServerUsername: string;
    irdetoServerPassword: string;
    irdetoServerAuthMethod: string;
    irdetoUsernamePlaceholder: string;
    irdetoPasswordPlaceholder: string;
    activeIndexes: number[];
    spekeRefServerUrl: string;
    verimatrixKid: string;    // 63 bytes
    verimatrixIssuer: string; // 63 bytes
    verimatrixAud: string;    // 63 bytes
    verimatrixUrl: string;    // 511 bytes
    verimatrixVrceiProt: string; // HTTP / HTTPS
    verimatrixVrceiVer: string; // 1.1 / 2.0
    verimatrixVrceiPort: number; // 0 - 65535
    verimatrixVrceiHost: string; // 255 bytes
    className: string;
	verimatrixAuthMethod: string;
	verimatrixKeyTypeWidevine: boolean;
	verimatrixKeyTypePlayReady: boolean;
	verimatrixKeyTypeFairplay: boolean;
	verimatrixCpixContentKeyPeriod: boolean;
	verimatrixCpixContentKeyUsageRule: boolean;
}

interface Props {

}

export default class DRMConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            drmSys: '',
            synamediaServerUrl: '',
            synamediaServerUsername: '',
            synamediaServerPassword: '',
            ezdrmServerUrl: '',
            ezdrmServerUsername: '',
            ezdrmServerPassword: '',
            ezdrmUsernamePlaceholder: '',
            ezdrmPasswordPlaceholder: '',
            ezdrmServerAuthMethod: '',
            ezdrmServerAwsAccessKeyId: '',
            ezdrmServerAwsSecretKey: '',
            ezdrmServerKeyTypeWidevine: false,
            ezdrmServerKeyTypePlayReady: false,
            ezdrmServerKeyTypeFairplay: false,
            irdetoGatewayUrl: '',
            irdetoServerUsername: '',
            irdetoServerPassword: '',
            irdetoServerAuthMethod: '',
            irdetoUsernamePlaceholder: '',
            irdetoPasswordPlaceholder: '',
            activeIndexes: [],
            spekeRefServerUrl: '',
            verimatrixKid: '',
            verimatrixIssuer: '',
            verimatrixAud: '',
            verimatrixUrl: '',
            verimatrixVrceiProt: '',
            verimatrixVrceiVer: '',
            verimatrixVrceiPort: 0,
            verimatrixVrceiHost: '',
            className: 'input-width-450',
			verimatrixAuthMethod : 'none',
			verimatrixKeyTypeWidevine: false,
			verimatrixKeyTypePlayReady: false,
			verimatrixKeyTypeFairplay: false,
			verimatrixCpixContentKeyPeriod: false,
			verimatrixCpixContentKeyUsageRule: false
        });
        this.fetchData();

    }

    handleClick = (e: any, titleProps: any) => {
        const {index} = titleProps;
        const {activeIndexes} = this.state;
        const newIndex = activeIndexes;

        const currentIndexPosition = activeIndexes.indexOf(index);
        if (currentIndexPosition > -1) {
            newIndex.splice(currentIndexPosition, 1);
        } else {
            newIndex.push(index);
        }

        this.setState({activeIndexes: newIndex});
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/decryptdrm';
        axios.post(url, {
            mode: 'get',
            defaults: {},
            options: [
                'drmSys',
                'synamediaServerUrl',
                'synamediaServerUsername',
                'synamediaServerPassword',
                'ezdrmServerUrl',
                'ezdrmServerUsername',
                'ezdrmServerPassword',
                'ezdrmServerAuthMethod',
                'ezdrmServerAwsAccessKeyId',
                'ezdrmServerAwsSecretKey',
                'ezdrmServerKeyTypeWidevine',
                'ezdrmServerKeyTypePlayReady',
                'ezdrmServerKeyTypeFairplay',
                'irdetoGatewayUrl',
                'irdetoServerUsername',
                'irdetoServerPassword',
                'irdetoServerAuthMethod',
                'spekeRefServerUrl',
                'verimatrixKid',
                'verimatrixIssuer',
                'verimatrixAud',
                'verimatrixUrl',
                'verimatrixVrceiProt',
                'verimatrixVrceiVer',
                'verimatrixVrceiPort',
                'verimatrixVrceiHost',
				'verimatrixKeyTypeWidevine',
				'verimatrixKeyTypePlayReady',
				'verimatrixKeyTypeFairplay',
				'verimatrixAuthMethod',
				'verimatrixCpixContentKeyPeriod',
				'verimatrixCpixContentKeyUsageRule'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    // // @ts-ignore
                    // synamediaPwd = myDecrypt(responseObject[3].value);
                    // // @ts-ignore
                    // ezdrmPwd = myDecrypt(responseObject[6].value);
                    _this.setState({
                        drmSys: responseObject[0].value,
                        synamediaServerUrl: responseObject[1].value,
                        synamediaServerUsername: responseObject[2].value,
                        synamediaServerPassword: responseObject[3].value,
                        ezdrmServerUrl: responseObject[4].value,
                        ezdrmServerUsername: responseObject[5].value,
                        ezdrmServerPassword: responseObject[6].value,
                        ezdrmServerAuthMethod: responseObject[7].value,
                        ezdrmServerAwsAccessKeyId: responseObject[8].value,
                        ezdrmServerAwsSecretKey: responseObject[9].value,
                        ezdrmServerKeyTypeWidevine: responseObject[10].value,
                        ezdrmServerKeyTypePlayReady: responseObject[11].value,
                        ezdrmServerKeyTypeFairplay: responseObject[12].value,
                        irdetoGatewayUrl: responseObject[13].value,
                        irdetoServerUsername: responseObject[14].value,
                        irdetoServerPassword: responseObject[15].value,
                        irdetoServerAuthMethod: responseObject[16].value,
                        spekeRefServerUrl: responseObject[17].value,
                        verimatrixKid: responseObject[18].value,
                        verimatrixIssuer: responseObject[19].value,
                        verimatrixAud: responseObject[20].value,
                        verimatrixUrl: responseObject[21].value,
                        verimatrixVrceiProt: responseObject[22].value,
                        verimatrixVrceiVer: responseObject[23].value,
                        verimatrixVrceiPort: responseObject[24].value,
                        verimatrixVrceiHost: responseObject[25].value,
						verimatrixKeyTypeWidevine: responseObject[26].value,
						verimatrixKeyTypePlayReady: responseObject[27].value,
						verimatrixKeyTypeFairplay: responseObject[28].value,
						verimatrixAuthMethod: responseObject[29].value,
						verimatrixCpixContentKeyPeriod: responseObject[30].value,
						verimatrixCpixContentKeyUsageRule: responseObject[31].value
                        });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });
    }

    updateConfig(e: any, data: any) {
        let url = 'http://default/api/config/section/options/decryptdrm';

        let options = [];

        options = [
            {
                'name': 'drmSys', 'value': this.state.drmSys
            }, {
                'name': 'synamediaServerUrl', 'value': this.state.synamediaServerUrl
            }, {
                'name': 'synamediaServerUsername', 'value': this.state.synamediaServerUsername
            }, {
                'name': 'synamediaServerPassword', 'value': this.state.synamediaServerPassword
            }, {
                'name': 'ezdrmServerUrl', 'value': this.state.ezdrmServerUrl
            }, {
                'name': 'ezdrmServerUsername', 'value': this.state.ezdrmServerUsername
            }, {
                'name': 'ezdrmServerPassword', 'value': this.state.ezdrmServerPassword
            }, {
                'name': 'spekeRefServerUrl', 'value': this.state.spekeRefServerUrl
            }, {
                'name': 'ezdrmServerAwsAccessKeyId', 'value': this.state.ezdrmServerAwsAccessKeyId
            }, {
                'name': 'ezdrmServerAwsSecretKey', 'value': this.state.ezdrmServerAwsSecretKey
            }, {
                'name': 'ezdrmServerKeyTypeWidevine', 'value': this.state.ezdrmServerKeyTypeWidevine
            }, {
                'name': 'ezdrmServerKeyTypePlayReady', 'value': this.state.ezdrmServerKeyTypePlayReady
            }, {
                'name': 'ezdrmServerKeyTypeFairplay', 'value': this.state.ezdrmServerKeyTypeFairplay
            }, {
                'name': 'ezdrmServerAuthMethod', 'value': this.state.ezdrmServerAuthMethod
            }, {
                'name': 'irdetoGatewayUrl', 'value': this.state.irdetoGatewayUrl
            }, {
                'name': 'irdetoServerUsername', 'value': this.state.irdetoServerUsername
            }, {
                'name': 'irdetoServerPassword', 'value': this.state.irdetoServerPassword
            }, {
                'name': 'irdetoServerAuthMethod', 'value': this.state.irdetoServerAuthMethod
            }, {
                'name': 'verimatrixKid', 'value': this.state.verimatrixKid
            }, {
                'name': 'verimatrixIssuer', 'value': this.state.verimatrixIssuer
            }, {
                'name': 'verimatrixAud', 'value': this.state.verimatrixAud
            }, {
                'name': 'verimatrixUrl', 'value': this.state.verimatrixUrl
            }, {
                'name': 'verimatrixVrceiProt', 'value': this.state.verimatrixVrceiProt
            }, {
                'name': 'verimatrixVrceiVer', 'value': this.state.verimatrixVrceiVer
            }, {
                'name': 'verimatrixVrceiPort', 'value': this.state.verimatrixVrceiPort
            }, {
                'name': 'verimatrixVrceiHost', 'value': this.state.verimatrixVrceiHost
            }, {
                'name': 'verimatrixKeyTypeWidevine', 'value': this.state.verimatrixKeyTypeWidevine
            }, {
                'name': 'verimatrixKeyTypePlayReady', 'value': this.state.verimatrixKeyTypePlayReady
            }, {
				'name': 'verimatrixKeyTypeFairplay', 'value': this.state.verimatrixKeyTypeFairplay
			}, {
				'name': 'verimatrixAuthMethod', 'value': this.state.verimatrixAuthMethod
			}, {
				'name': 'verimatrixCpixContentKeyPeriod', 'value': this.state.verimatrixCpixContentKeyPeriod
			}, {
				'name': 'verimatrixCpixContentKeyUsageRule', 'value': this.state.verimatrixCpixContentKeyUsageRule
			}
			
        ];

        axios.post(url, {
            mode: 'modify',
            defaults: {},
            options: options
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('DRM configuration applied');
                } else {
                    Toast.error('Failed to update DRM configuration');
                }

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Failed to update DRM configuration');
            });
    }

    downloadKey(filename: string) {
        let url = 'http://default/api/config/section/options/decryptdrm';
        axios.post(url, {
            mode: 'get',
            defaults: {},
            options: [
                'verimatrixPublicKey'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    let stringObject = responseObject[0].value;
                    fileDownload(stringObject, filename);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('Download Verimatrix PPK file error: ', error);
            });
    }

    ValidateURLIPv6(str: string, type: number) {
        let validUrl;
        // tslint:disable-next-line:switch-default
        switch (type) {
            case 1:
                this.setState({spekeRefServerUrl: str});
                break;
            case 2:
                this.setState({synamediaServerUrl: str});
                break;
            case 3:
                this.setState({ezdrmServerUrl: str});
                break;
            case 4:
                this.setState({irdetoGatewayUrl: str});
                break;
            case 5:
                this.setState({verimatrixUrl: str});
                break;
        }

        try {
            validUrl = new URL(str);
        } catch (e) {
            // do nothing
        }

        if (validUrl) {
            this.setState({className: 'input-width-450'});
        } else {
            this.setState({className: 'red-input-width-450'});
        }
    }

    render() {
        const {activeIndexes} = this.state;
        const drmOptions = [
            {value: 'disabled', text: 'Disabled'},
            {value: 'synamedia', text: 'Synamedia'},
            {value: 'spekeref', text: 'SPEKE'},
            {value: 'ezdrm', text: 'EZDRM'},
            {value: 'irdeto', text: 'Irdeto'},
            {value: 'verimatrix', text: 'Verimatrix'},
            {value: 'verimatrixvrcei', text: 'Verimatrix ViewRight CEI'}
        ];

        const ezdrmAuthMethodOptions = [
            {value: 'none', text: 'No Auth', userPlaceholder: '', passPlaceholder: ''},
            {value: 'basic', text: 'Basic', userPlaceholder: 'User ID', passPlaceholder: 'Password'},
            {value: 'awsv4sig', text: 'AWS Signature', userPlaceholder: 'AWS Access Key ID', passPlaceholder: 'Secret key'},
            {value: 'digest', text: 'Digest', userPlaceholder: 'Username', passPlaceholder: 'Password'}
        ];
		
		const verimatrixAuthOptions = [
			{value: 'none', text: 'No Auth', userPlaceholder: '', passPlaceholder: ''},
			{value: 'token', text: 'Token Authentication', userPlaceholder: '', passPlaceholder: ''},
		];

        const irdetoAuthMethodOptions = [
            {value: 'basic', text: 'Basic', userPlaceholder: 'User ID', passPlaceholder: 'Password'}
        ];

        return (
            <React.Fragment>
                <div className="assetAliasFilters">
                    <Label className="system-config-pageHeader">
                        Diagnostics
                    </Label>
                    <Button
                        floated="right"
                        className="rightButton"
                        content="Apply"
                        title="Update Config"
                        onClick={(e, data) => this.updateConfig(e, data)}
                    />
                </div>
                <div className="vertical-flex-main">
                    <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">DRM System</Segment>
                        <Segment>
                            <Form>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        System
                                    </Label>
                                    <Dropdown
                                        search
                                        options={drmOptions}
                                        selection
                                        value={this.state.drmSys}
                                        onChange={(event: any, data: any) => this.setState({drmSys: data.value, className: 'input-width-450'})}
                                    />
                                </Form.Group>
                                {(this.state.drmSys !== 'disabled') ?
                                    <Accordion defaultActiveIndex={0}>
                                        <Accordion.Title
                                            active={activeIndexes.includes(0)}
                                            index={0}
                                            onClick={this.handleClick}
                                        >
                                            <Icon name="dropdown"/>
                                            Additional Configuration
                                        </Accordion.Title>
                                        <Accordion.Content active={activeIndexes.includes(0)}>
                                            {(this.state.drmSys === 'spekeref') ?
                                                <React.Fragment>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Server URL
                                                        </Label>
                                                        <Input
                                                            className={this.state.className}
                                                            maxLength={511}
                                                            value={this.state.spekeRefServerUrl}
                                                            onChange={(e: any, data: any) => this.ValidateURLIPv6(data.value, 1)}
                                                        />
                                                    </Form.Group>
                                                </React.Fragment> : ''}
                                            {(this.state.drmSys === 'synamedia') ?
                                                <React.Fragment>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Server URL
                                                        </Label>
                                                        <Input
                                                            className={this.state.className}
                                                            maxLength={511}
                                                            value={this.state.synamediaServerUrl}
                                                            onChange={(e: any, data: any) => this.ValidateURLIPv6(data.value, 2)}
                                                        />
                                                    </Form.Group>
                                                    {/*<Form.Group grouped>*/}
                                                    {/*    <Label className="right-align-label">*/}
                                                    {/*        Server Username*/}
                                                    {/*    </Label>*/}
                                                    {/*    <Input*/}
                                                    {/*        maxLength={63}*/}
                                                    {/*        value={this.state.synamediaServerUsername}*/}
                                                    {/*        onChange={(e: any, data: any) => this.setState({synamediaServerUsername: data.value})}*/}
                                                    {/*    />*/}
                                                    {/*</Form.Group>*/}
                                                    {/*<Form.Group grouped>*/}
                                                    {/*    <Label className="right-align-label">*/}
                                                    {/*        Server Password*/}
                                                    {/*    </Label>*/}
                                                    {/*    <Input*/}
                                                    {/*        maxLength={63}*/}
                                                    {/*        type="password"*/}
                                                    {/*        value={this.state.synamediaServerPassword}*/}
                                                    {/*        onChange={(e: any, data: any) => this.setState({synamediaServerPassword: data.value})}*/}
                                                    {/*    />*/}
                                                    {/*</Form.Group>*/}
                                                </React.Fragment> : ''}
                                            {(this.state.drmSys === 'ezdrm') ?
                                                <React.Fragment>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Server URL
                                                        </Label>
                                                        <Input
                                                            className={this.state.className}
                                                            maxLength={511}
                                                            value={this.state.ezdrmServerUrl}
                                                            onChange={(e: any, data: any) => this.ValidateURLIPv6(data.value, 3)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Authentication
                                                        </Label>
                                                        <Dropdown
                                                            search
                                                            options={ezdrmAuthMethodOptions}
                                                            selection
                                                            value={this.state.ezdrmServerAuthMethod}
                                                            onChange={(event: any, data: any) => this.setState(
                                                                {ezdrmServerAuthMethod: data.value,
                                                                    ezdrmUsernamePlaceholder: data.options.find((o: any) => o.value === data.value).userPlaceholder,
                                                                    ezdrmPasswordPlaceholder: data.options.find((o: any) => o.value === data.value).passPlaceholder
                                                                })}
                                                        />
                                                    </Form.Group>
                                                    {(this.state.ezdrmServerAuthMethod !== 'none' && this.state.ezdrmServerAuthMethod !== 'awsv4sig') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label"/>
                                                        <Input
                                                            maxLength={63}
                                                            placeholder={this.state.ezdrmUsernamePlaceholder}
                                                            value={this.state.ezdrmServerUsername}
                                                            onChange={(e: any, data: any) => this.setState({ezdrmServerUsername: data.value})}
                                                        />
                                                    </Form.Group>}
                                                    {(this.state.ezdrmServerAuthMethod !== 'none' && this.state.ezdrmServerAuthMethod !== 'awsv4sig') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label"/>
                                                        <Input
                                                            maxLength={63}
                                                            placeholder={this.state.ezdrmPasswordPlaceholder}
                                                            type="password"
                                                            value={this.state.ezdrmServerPassword}
                                                            onChange={(e: any, data: any) => this.setState({ezdrmServerPassword: data.value})}
                                                        />
                                                    </Form.Group>}
                                                    {this.state.ezdrmServerAuthMethod === 'awsv4sig' &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label"/>
                                                        <Input
                                                            maxLength={63}
                                                            placeholder={this.state.ezdrmUsernamePlaceholder}
                                                            value={this.state.ezdrmServerAwsAccessKeyId}
                                                            onChange={(e: any, data: any) => this.setState({ezdrmServerAwsAccessKeyId: data.value})}
                                                        />
                                                    </Form.Group>}
                                                    {this.state.ezdrmServerAuthMethod === 'awsv4sig' &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label"/>
                                                        <Input
                                                            maxLength={63}
                                                            placeholder={this.state.ezdrmPasswordPlaceholder}
                                                            type="password"
                                                            value={this.state.ezdrmServerAwsSecretKey}
                                                            onChange={(e: any, data: any) => this.setState({ezdrmServerAwsSecretKey: data.value})}
                                                        />
                                                    </Form.Group>}
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Keys
                                                        </Label>
                                                        <Checkbox
                                                            className="config-checkbox paddingLeft-10"
                                                            checked={this.state.ezdrmServerKeyTypeWidevine}
                                                            onChange={(e: any, data: any) => this.setState({ezdrmServerKeyTypeWidevine: data.checked})}
                                                        />
                                                        <Label className="left-align-label-300">
                                                            Widevine
                                                        </Label>
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label"/>
                                                        <Checkbox
                                                            className="config-checkbox paddingLeft-10"
                                                            checked={this.state.ezdrmServerKeyTypePlayReady}
                                                            onChange={(e: any, data: any) => this.setState({ezdrmServerKeyTypePlayReady: data.checked})}
                                                        />
                                                        <Label className="left-align-label-300">
                                                            PlayReady
                                                        </Label>
                                                    </Form.Group>
                                                </React.Fragment> : ''}
                                            {(this.state.drmSys === 'irdeto') ?
                                                <React.Fragment>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Gateway URL
                                                        </Label>
                                                        <Input
                                                            className={this.state.className}
                                                            maxLength={511}
                                                            value={this.state.irdetoGatewayUrl}
                                                            onChange={(e: any, data: any) => this.ValidateURLIPv6(data.value, 4)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Authentication
                                                        </Label>
                                                        <Dropdown
                                                            search
                                                            options={irdetoAuthMethodOptions}
                                                            selection
                                                            value={this.state.irdetoServerAuthMethod}
                                                            onChange={(event: any, data: any) => this.setState({irdetoServerAuthMethod: data.value})}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label"/>
                                                        <Input
                                                            maxLength={63}
                                                            placeholder="Username"
                                                            value={this.state.irdetoServerUsername}
                                                            onChange={(e: any, data: any) => this.setState({irdetoServerUsername: data.value})}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label"/>
                                                        <Input
                                                            maxLength={63}
                                                            placeholder="Password"
                                                            type="password"
                                                            value={this.state.irdetoServerPassword}
                                                            onChange={(e: any, data: any) => this.setState({irdetoServerPassword: data.value})}
                                                        />
                                                    </Form.Group>
                                                </React.Fragment> : ''}
                                            {(this.state.drmSys === 'verimatrix') ?
                                                <React.Fragment>
													<Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Authentication
                                                        </Label>
                                                        <Dropdown
                                                            search
                                                            options={verimatrixAuthOptions}
                                                            selection
                                                            value={this.state.verimatrixAuthMethod}
                                                            onChange={(event: any, data: any) => this.setState({verimatrixAuthMethod: data.value})}
                                                        />
                                                    </Form.Group>
													{(this.state.verimatrixAuthMethod === 'token') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label-tweak"/>
                                                        <Label className="left-align-label-550">
                                                            Download the public key and configure the Surveyor ABR Active in the Verimatrix server to authenticate the probe.
                                                        </Label>
                                                    </Form.Group>}
													{(this.state.verimatrixAuthMethod === 'token') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label-tweak"/>
                                                        <Button
                                                            id="download-key-button"
                                                            content="Download"
                                                            onClick={(event, data) => this.downloadKey('verimatrix.pub')}
                                                        />
                                                    </Form.Group>}
													{(this.state.verimatrixAuthMethod === 'token') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label-tweak"/>
                                                        <Label className="left-align-label-550">
                                                            Enter the KID, ISS, and AUD values returned from Verimatrix after adding the public key.
                                                        </Label>
                                                    </Form.Group>}
													{(this.state.verimatrixAuthMethod === 'token') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            KID
                                                        </Label>
                                                        <Input
                                                            className="input-width-450"
                                                            maxLength={63}
                                                            value={this.state.verimatrixKid}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixKid: data.value})}
                                                        />
                                                    </Form.Group>}
													{(this.state.verimatrixAuthMethod === 'token') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            ISS (issuer)
                                                        </Label>
                                                        <Input
                                                            className="input-width-450"
                                                            maxLength={63}
                                                            value={this.state.verimatrixIssuer}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixIssuer: data.value})}
                                                        />
                                                    </Form.Group>}
													{(this.state.verimatrixAuthMethod === 'token') &&
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            AUD (audience)
                                                        </Label>
                                                        <Input
                                                            className="input-width-450"
                                                            maxLength={63}
                                                            value={this.state.verimatrixAud}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixAud: data.value})}
                                                        />
                                                    </Form.Group>}										
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label-tweak"/>
                                                        <Label className="left-align-label-550">
                                                            Add the Verimatrix server URL for the probe to use for key requests.
                                                        </Label>
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            CPIX Server URL
                                                        </Label>
                                                        <Input
                                                            className={this.state.className}
                                                            maxLength={511}
                                                            value={this.state.verimatrixUrl}
                                                            onChange={(e: any, data: any) => this.ValidateURLIPv6(data.value, 5)}
                                                        />
                                                    </Form.Group>
													<Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Keys(If required)
                                                        </Label>
                                                        <Checkbox
                                                            className="config-checkbox paddingLeft-10"
                                                            checked={this.state.verimatrixKeyTypeWidevine}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixKeyTypeWidevine: data.checked})}
                                                        />	
                                                        <Label className="left-align-label-300">
                                                            Widevine
                                                        </Label>
                                                    </Form.Group>
													<Form.Group grouped>
														<Label className="right-align-label"/>
                                                        <Checkbox
                                                            className="config-checkbox paddingLeft-10"
                                                            checked={this.state.verimatrixKeyTypePlayReady}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixKeyTypePlayReady: data.checked})}
                                                        />
                                                        <Label className="left-align-label-300">
                                                            PlayReady
                                                        </Label>
                                                    </Form.Group>
													<Form.Group grouped>
														<Label className="right-align-label"/>
                                                        <Checkbox
                                                            className="config-checkbox paddingLeft-10"
                                                            checked={this.state.verimatrixKeyTypeFairplay}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixKeyTypeFairplay: data.checked})}
                                                        />
                                                        <Label className="left-align-label-300">
                                                            FairPlay
                                                        </Label>
                                                    </Form.Group>
													<Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            CPIX Elements(If required)
                                                        </Label>
                                                        <Checkbox
                                                            className="config-checkbox paddingLeft-10"
                                                            checked={this.state.verimatrixCpixContentKeyPeriod}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixCpixContentKeyPeriod: data.checked})}
                                                        />
														<Label className="left-align-label-300">														
															ContentKeyPeriod
														</Label>															
                                                    </Form.Group>
													<Form.Group grouped>
                                                        <Label className="right-align-label"/>                                                            
                                                        <Checkbox
                                                            className="config-checkbox paddingLeft-10"
                                                            checked={this.state.verimatrixCpixContentKeyUsageRule}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixCpixContentKeyUsageRule: data.checked})}
                                                        />
														<Label className="left-align-label-300">
                                                            ContentKeyUsageRule
                                                        </Label>														
                                                    </Form.Group>
                                                </React.Fragment> : ''}
                                            {(this.state.drmSys === 'verimatrixvrcei') ?
                                                <React.Fragment>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Key Host
                                                        </Label>
                                                        <Input
                                                            className="input-width-325"
                                                            maxLength={255}
                                                            value={this.state.verimatrixVrceiHost}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixVrceiHost: data.value})}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Protocol
                                                        </Label>
                                                        <Config.RadioList
                                                            id="drm.protocol"
                                                            caption=""
                                                            hide={false}
                                                            options={[{
                                                                value: 'HTTP',
                                                                text: 'HTTP'
                                                            }, {
                                                                value: 'HTTPS',
                                                                text: 'HTTPS'
                                                            }]}
                                                            defaultValue={this.state.verimatrixVrceiProt}
                                                            onChange={(value: any) => this.setState({ verimatrixVrceiProt: value })}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            Port
                                                        </Label>
                                                        <Input
                                                            type="number"
                                                            className="small-input"
                                                            min="0"
                                                            max="65535"
                                                            value={this.state.verimatrixVrceiPort}
                                                            onChange={(e: any, data: any) => this.setState({verimatrixVrceiPort: data.value})}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group grouped>
                                                        <Label className="right-align-label">
                                                            CEI Version
                                                        </Label>
                                                        <Config.RadioList
                                                            id="drm.version"
                                                            caption=""
                                                            hide={false}
                                                            options={[{
                                                                value: '1.1',
                                                                text: '1.1'
                                                            }, {
                                                                value: '2.0',
                                                                text: '2.0'
                                                            }]}
                                                            defaultValue={this.state.verimatrixVrceiVer}
                                                            onChange={(value: any) => this.setState({ verimatrixVrceiVer: value })}
                                                        />
                                                    </Form.Group>
                                                </React.Fragment> : ''}
                                        </Accordion.Content>
                                    </Accordion> : ''}
                            </Form>
                        </Segment>
                    </Segment.Group>
                </div>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/drmConfig.tsx